<h2 mat-dialog-title>{{ 'orders.linkToHubReport' | transloco }}</h2>
<mat-dialog-content>
    @for (node of displayNodes; track node.id) {
    <mat-checkbox [disabled]="!!selectedNode && selectedNode !== node" (change)="onHubReportCheckboxClick(node)">{{ 'orders.linkToHubReportWithReference' | transloco }} <b>"{{node.hubReportReference}}"</b></mat-checkbox>
    <br />
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>{{ 'common.buttons.cancel' | transloco }}</button>
    <button mat-raised-button data-testid="ubo-continue-button" (click)="onLink()" [disabled]="!selectedNode"
        color="primary" mat-dialog-close>
        {{ 'orders.link' | transloco }}
    </button>
</mat-dialog-actions>